import { IOption } from '../../interfaces/Fields';

const DEFAULT_OPTIONS_SEPARATOR = '\n';
const DEFAULT_VALUE_SEPARATOR = ';';

export class OptionsParser {

    /**
   * Parses the given options string to the values, labels and optional icons.
   * 
   * @param {string} optionsString                                  The options string to parse.
   * @param {string} [optionsSeparator=DEFAULT_OPTIONS_SEPARATOR]   The separator between the different options in the optionsString. Defaults to '\n'.
   * 
   * @returns An array with options.
   */
  public static parseOptionsString(optionsString: string, optionsSeparator: string = DEFAULT_OPTIONS_SEPARATOR): IOption[] {
    if (!optionsString) {
      return [];
    }

    const options = optionsString.split(optionsSeparator).map(option => {
      const splitted = option.split(DEFAULT_VALUE_SEPARATOR).map(item => item.trim());
      const optionValue = splitted[0];
      // Labels are optional, and are equal to the value if not provided
      const optionLabel = splitted.length > 1 ? splitted[1] : splitted[0];
      
      // Icons are optional
      const optionIcon = splitted.length > 2 ? splitted[2] : null;

      return {
        value: optionValue,
        label: optionLabel,
        icon: optionIcon,
      };
    });

    return options;
  }

  /**
   * Parses the given options string to the values, labels and optional icons.
   * 
   * @deprecated
   * Old components use this method with separate values, labels and icon arrays, but we should use 'parseOptionsString' instead where all those values
   * are in the same object in one array.
   * This method is still needed for components that use a 'datasource', because in the ComponentStoreHelper it is assumed that there are 'valueoptions'.
   * 
   * @param {string} optionsString                                  The options string to parse.
   * @param {string} [optionsSeparator=DEFAULT_OPTIONS_SEPARATOR]   The separator between the different options in the optionsString. Defaults to '\n'.
   * 
   * @returns An object with the parsed values, labels and icons.
   */
  public static parseOptionsStringOld(optionsString: string, optionsSeparator: string = DEFAULT_OPTIONS_SEPARATOR): { values: string[], labels: string[], icons: string[] } {

    const options = this.parseOptionsString(optionsString, optionsSeparator);

    const values = [];
    const labels = [];
    const icons = [];
    
    options.forEach(option => {
      values.push(option.value);
      labels.push(option.label);
      icons.push(option.icon);
    });

    return {
      values,
      labels,
      icons,
    };
  }
}